import { useState } from "react";

type Status = "idle" | "loading" | "success";

export default function UpdateAvailableModal({ onUpdate }: { onUpdate: () => void }) {
    const [status, setStatus] = useState<Status>("idle");

    const handleUpdate = () => {
        if (status !== "idle") return;
        setStatus("loading");

        setTimeout(() => {
            setStatus("success");
            // Giữ màn hình "thành công" một nhịp rồi mới tắt modal + reload thật sự.
            setTimeout(onUpdate, 1200);
        }, 2000);
    };

    return (
        <div className="fixed inset-0 z-[100] bg-black/40 flex items-end sm:items-center justify-center p-4">
            <div className="w-full max-w-sm bg-white rounded-2xl p-5 shadow-xl space-y-3 text-center animate-slide-up">
                <div
                    className={`w-12 h-12 mx-auto rounded-full flex items-center justify-center ${status === "success" ? "bg-emerald-100 text-emerald-600" : "bg-sky-100 text-sky-600"
                        } ${status === "idle" ? "animate-pulse" : ""}`}
                >
                    {status === "success" ? (
                        <i className="ri-checkbox-circle-line text-2xl"></i>
                    ) : (
                        <i className={`ri-refresh-line text-2xl ${status === "loading" ? "animate-spin" : ""}`}></i>
                    )}
                </div>

                <h3 className="text-sm font-bold text-gray-800">
                    {status === "success" ? "Cập nhật thành công!" : "Đã có phiên bản mới"}
                </h3>
                <p className="text-xs text-gray-500">
                    {status === "success"
                        ? "Ứng dụng đã được cập nhật lên phiên bản mới nhất."
                        : status === "loading"
                            ? "Đang tải phiên bản mới nhất..."
                            : "Vui lòng cập nhật để tiếp tục sử dụng với phiên bản mới nhất."}
                </p>

                {status === "loading" && (
                    <div className="h-1.5 w-full rounded-full bg-sky-100 overflow-hidden">
                        <div className="h-full w-1/3 rounded-full bg-sky-500 animate-progress-indeterminate" />
                    </div>
                )}

                {status !== "success" && (
                    <button
                        onClick={handleUpdate}
                        disabled={status === "loading"}
                        className="w-full bg-sky-500 text-white font-semibold py-2.5 rounded-xl cursor-pointer active:scale-[0.99] transition-all disabled:opacity-70 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                    >
                        {status === "loading" ? (
                            <>
                                <i className="ri-loader-4-line animate-spin text-base"></i>
                                Đang cập nhật...
                            </>
                        ) : (
                            "Cập nhật ngay"
                        )}
                    </button>
                )}
            </div>
        </div>
    );
}
